// extracted by mini-css-extract-plugin
module.exports = {"criteria":"grantEligibility_criteria__2L1O3","criteraImage":"grantEligibility_criteraImage__2_EDp","eligibility":"grantEligibility_eligibility__2oG6A"};